import HTTP from "libs/http";
import fetchEventSource from 'libs/http/fetchEventSource';
class Chat extends HTTP {
  async postMessage(params: { knowledgeId?: string; utterance: string }) {
    const response = await this.post("/chatbot-server/api/chat", params);
    return response;
  }
  async retrieveRobotsInfo() {
    const response = await this.get("/chatbot-server/api/robots");
    return response;
  }
  async getHome() {
    return await this.post("/homepage/get");
  }
  async getChatHistory() {
    return await this.post('/chat/history', {});
  }
  async getBot() {
    return await this.post("/bot/get");
  }
  async sendMessage(text: string) {
    return await this.post("/chat", {
      query: text,
    });
  }

  async sendMessageLLM(params: {} , callback: any) {
    fetchEventSource(params, (res: any) => {
      // return res.reply
      // console.log(res)
      callback(res);
    });
  }

  /**
   * 获取 sse 接口上下文需要的session_id
   * @returns 
   */
  async connetctSSE() {
    return await this.post("/chatStream/connect", {});
  }

  async makeAction(id: number, data: any) {
    return await this.post("/action", {
      id,
      data,
    });
  }
  async questionAutoMatch(query: string) {
    return await this.post("/auto_completion/query", {
      query,
      role: 1,
    });
  }

  async getSkillList() {
    return await this.post("/homepage/skill_intent_list_pc");
  }

  async chatStreamConnect() {
    return await this.post('/ssc-ai-server/chatStream/connect'); // 这部分接口 在nginx 上做了反向代理处理，实际接口只有 /chatStream/connect
  }

  async cPromptList(params: any) {
    return await this.post('/ssc-ai-server/cPrompt/list', params);
  }

  async cPromptListUpdate(params: any) {
    return await this.post('/ssc-ai-server/cPrompt/update', params);
  }
}
export default new Chat();
